<template>
  <div class="main">
    <el-dialog
      :close-on-click-modal="false"
      title="证书列表"
      :visible.sync="openData.bookState"
      width="700px"
      @close="dialogClose"
    >
      <el-form
        :rules="formDataRule"
        ref="formDataRef"
        :model="certificateForm"
        label-width="90px"
        :disabled="openData.booTitle === '查看'"
      >
        <el-form-item label="证书类型:" prop="certificateTypeId">
          <el-select
            v-model="certificateForm.certificateTypeId"
            placeholder="请选择"
            style="width: 100%"
            @change="getCertiNameList"
          >
            <el-option
              v-for="(item, index) in certificateTypeList"
              :key="index"
              :label="item.cut"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书名称:" prop="certificateNameId">
          <el-select
            v-model="certificateForm.certificateNameId"
            placeholder="请选择"
            style="width: 100%"
            @change="getCertifiName"
          >
            <el-option
              v-for="(item, index) in certificateNameList"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书编码:" prop="certificateCode">
          <el-input
            v-model="certificateForm.certificateCode"
            placeholder="请输入"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="发证时间:" prop="certificateTime">
          <el-date-picker
            v-model="certificateForm.certificateTime"
            type="datetime"
            placeholder="请选择时间"
            clearable
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="上传图片:" prop="photo">
          <el-upload
            style="width: 178px"
            :disabled="openData.booTitle === '查看'"
            class="avatar-uploader2"
            :action="baseUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload"
          >
            <img
              alt
              v-if="certificateForm.photo"
              :src="certificateForm.photo"
              class="avatar2"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="footer" v-if="openData.booTitle != '查看'">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button @click="dialogClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
import exportVue from "@/utils/exportVue"
export default {
  props: ["openData"],
  data() {
    return {
      baseUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      certificateForm: {
        certificateTypeId: "",
        certificateNameId: "",
        certificateTypeName: "",
        certificateName: "",
        photo: "",
        certificateCode: "",
        certificateTime: "",
      },
      lookcertifiForm: {},
      certificateTypeList: [],
      certificateNameList: [],
      formDataRule: {
        certificateTypeId: [
          {
            required: true,
            message: "证书类型不能为空",
            trigger: "blur",
          },
        ],
        certificateCode: [
          {
            required: true,
            message: "证书编码不能为空",
            trigger: "blur",
          },
        ],
        certificateNameId: [
          {
            required: true,
            message: "证书名称不能为空",
            trigger: "blur",
          },
        ],
        photo: [
          {
            required: true,
            message: "图片不能为空",
            trigger: "blur",
          },
        ],
        certificateTime: [
          {
            required: true,
            message: "发布不能为空",
            trigger: "blur",
          },
        ],
      },
    }
  },
  created() {
    this.getCertificateTypeList()
    this.certificateForm = {
      certificateTypeId: "",
      certificateNameId: "",
      certificateTypeName: "",
      certificateName: "",
      photo: "",
      certificateCode: "",
      certificateTime: "",
    }
    console.log(this.openData.cerdata, this.openData)
    if (this.openData.booTitle != "新增") {
      console.log(this.certificateTypeList, this.certificateNameList)
      this.getCertiNameList(this.openData.cerdata.certificateTypeId)
      this.certificateForm = this.openData.cerdata
      console.log(this.openData.cerdata)
    }
    //this.certificateForm=this.openData.cerdata
  },
  mounted() {},
  methods: {
    // 证书名称
    getCertiNameList(val) {
      console.log(this.certificateTypeList)
      if (this.certificateTypeList.length > 0) {
        var obj = {}
        obj = this.certificateTypeList.find((item) => {
          return item.id === val
        })
        this.certificateForm.certificateType = obj.cut
      }
      this.certificateNameList = []
      this.certificateForm.certificateNameId = ""
      this.certificateForm.certificateName = ""
      this.$forceUpdate()
      this.$http
        .request({
          url: "/jjyl/admin/ststemdata/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
            type: "3",
            cutId: val,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.certificateNameList = res.content.list || []
            if (this.openData.booTitle != "新增") {
              //this.getData()
            }
          }
        })
    },
    //获取证书名称
    getCertifiName(val) {
      var obj1 = {}
      obj1 = this.certificateNameList.find((item) => {
        return item.id === val
      })
      this.certificateForm.certificateName = obj1.name
    },
    // 获取信息
    getData() {
      const self = this
      let params = {
        id: this.openData.ids,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStaffCertificateinfo/getById",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            let jsonTemp = { ...res.content }
            self.certificateForm.id = jsonTemp.id
            self.certificateForm.certificateTypeId = jsonTemp.certificateTypeId
            self.certificateForm.certificateTypeName =
              jsonTemp.certificateTypeName
            self.certificateForm.certificateNameId = jsonTemp.certificateNameId
            self.certificateForm.certificateNam = jsonTemp.certificateNam
            self.certificateForm.photo = jsonTemp.photo
            self.certificateForm.certificateCode = jsonTemp.certificateCode
            self.certificateForm.certificateTime = jsonTemp.certificateTime
            this.getCertiNameList()
          } else {
            this.$message.success(res.message)
          }
        })
    },
    //获取证书类型
    getCertificateTypeList() {
      this.$http
        .request({
          url: "/jjyl/admin/ststemdata/info/findList",
          method: "POST",
          data: {
            pageNo: 1,
            pageSize: 1000,
            type: "5",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              return
            }
            this.certificateTypeList = res.content.list || []
          }
        })
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 5
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      //   return isJPG
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!")
        return isLt2M
      }
    },
    // 新增证书信息上传图片
    handleAvatarSuccess2(res, file) {
      this.$set(this.certificateForm, "photo", res.content)
    },
    // 保存信息
    save() {
      exportVue.$emit("certificateForm", this.certificateForm)
      this.$emit("cancleOpen", true)
      // let url = "/ypt/admin/serviceStaffCertificateinfo/save"
      // this.$http
      //     .request({
      //         url,
      //         method: "POST",
      //         data: {
      //             servicePersonId: this.openData.userId,
      //             ...this.certificateForm,
      //         },
      //     })
      //     .then((res) => {
      //         if (res.code === 200) {
      //             this.$message.success(res.message)
      //             this.$emit("cancleOpen", true)
      //         } else {
      //             this.$message.success(res.message)
      //         }
      //     })
    },
    // 关闭人员信息
    dialogClose() {
      this.$emit("cancleOpen", false)
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  border-top: 1px solid #eee;
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
/deep/ .avatar-uploader2 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader2 .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

/deep/ .avatar2 {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
